'use strict';

var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var Tabs = require('../../../node_modules/@material-ui/core/esm/Tabs/Tabs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PillTabs = withStyles["default"](function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.secondary[200],
      height: '40px',
      borderRadius: '100px',
      minHeight: '40px',
      padding: theme.spacing(0.5),
      width: 'fit-content'
    },
    indicator: {
      display: 'none'
    }
  };
})(function (props) {
  return React__default["default"].createElement(Tabs["default"], props);
});

module.exports = PillTabs;
